const PAGES = {
  EXPIRY_DATE: "EXPIRY_DATE",
  ONE_TIME_CODE: "ONE_TIME_CODE",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

const initialActivateCardState = {
  page: PAGES.EXPIRY_DATE,
  cardActivationUrl: null,
  account: null,
  accountInfo: null,
  errorType: null,
  maskedMobileNumber: null,
  verifyOtpAction: null,
  resendOtpAction: null,
};

function activateCardReducer(state, action) {
  switch (state.page) {
    case PAGES.EXPIRY_DATE: {
      switch (action.type) {
        case "CARD_ACTIVATION_URL_FOUND": {
          return {
            ...state,
            cardActivationUrl: action.cardActivationUrl,
          };
        }

        case "CARD_ACTIVATION_URL_NOT_FOUND": {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "CARD_ACTIVATION_NOT_AVAILABLE",
          };
        }

        case "ACCOUNT_INFO_LOADED": {
          return {
            ...state,
            account: action.account,
            accountInfo: action.accountInfo,
          };
        }

        case "EXPIRY_DATE_VERIFIED_SUCCESSFULLY": {
          return {
            ...state,
            page: PAGES.ONE_TIME_CODE,
            maskedMobileNumber: action.maskedMobileNumber,
            verifyOtpAction: action.verifyOtpAction,
            resendOtpAction: action.resendOtpAction,
          };
        }

        case "CARD_ACTIVATION_LOCKED": {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "CARD_ACTIVATION_LOCKED",
          };
        }

        case "INVALID_RESPONSE":
        case "EXPIRY_DATE_VERIFICATION_FAILED": {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "UNEXPECTED_ERROR",
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.ONE_TIME_CODE: {
      switch (action.type) {
        case "ONE_TIME_CODE_VERIFIED_SUCCESSFULLY": {
          return {
            ...state,
            page: PAGES.SUCCESS,
          };
        }

        case "ONE_TIME_CODE_VERIFICATION_FAILED":
        case "ONE_TIME_CODE_RESEND_FAILED": {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "UNEXPECTED_ERROR",
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
}

export { PAGES, initialActivateCardState, activateCardReducer };
